"use client"

import * as Sentry from "@sentry/nextjs"
import Image from "next/image"

import logoIconPng from "@/imagesCommon/errorPages/logoicon.png"

const GlobalError = ({ error, reset }: { error: Error; reset: () => void }) => {
  Sentry.captureException(error)
  return (
    <div
      style={{
        width: "100%",
        padding: "10px 15px 0px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        minHeight: "100vh",
        textAlign: "center",
      }}
    >
      <a href={process.env.NEXT_PUBLIC_CR_TOP_URL}>
        <Image src={logoIconPng} width={150} height={49} alt="クレヨンのロゴ" />
      </a>
      <h2
        style={{
          fontSize: "30px",
          marginTop: "20px",
          marginBottom: "10px",
          fontFamily: "inherit",
          fontWeight: 500,
          lineHeight: "1.1",
          color: "inherit",
        }}
      >
        Server Error 500
      </h2>
      <p>予期せぬエラーが発生しました</p>
      <div style={{ textAlign: "center" }}>
        <a
          href={process.env.NEXT_PUBLIC_CR_TOP_URL}
          style={{
            justifyContent: "center",
            alignItems: "center",
            marginTop: "20px",
            lineHeight: "20px",
            cursor: "pointer",
            userSelect: "none",
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            boxShadow: "inset 0 -3px 5px rgba(100, 100, 100, 0.05)",
            borderRadius: "4px",
            color: "#333",
            display: "inline-flex",
            padding: "10px 16px",
            fontSize: "18px",
            fontWeight: 400,
            width: "100%",
          }}
        >
          TOPへ戻る
        </a>
      </div>
      <button type="button" onClick={() => reset()} style={{ display: "none" }}>
        Try again
      </button>
    </div>
  )
}

export default GlobalError
